<template>
    <div id="container">
        <div id="content">
            <h1>Contact Notes with LS and AS</h1>
            <a :href="'/api/report/contact-notes-with-ls-and-as.xlsx'" target="_blank">Download as CSV</a><br><br>
            <table v-loading="loading">
                <tbody>
                <tr>
                    <th>Academic Year</th>
                    <th colspan="2">Total Contact Notes with LS</th>
                    <th colspan="2">Total Contact Notes with Assistive Tech</th>
                </tr>
                <tr>
                    <th></th>
                    <th>All Students</th>
                    <th>CUMC Only</th>
                    <th>All Students</th>
                    <th>CUMC Only</th>
                </tr>

                <template v-for="(row, index) in data">
                    <tr :key="index">
                        <td>{{ row.name }}</td>
                        <td>{{ row.total_learning_specialist }}</td>
                        <td>{{ row.total_learning_specialist_cumc }}</td>
                        <td>{{ row.total_assistive }}</td>
                        <td>{{ row.total_assistive_cumc }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        metaInfo() {
            return {
                title: "Contact Notes with LS and AS"
            }
        },
        components: {},
        data() {
            return {
                data: [],
                loading: false
            }
        },
        methods: {
            load: function () {
                this.loading = true;
                this.getData();

            },
            getData: function () {
                this.loading = true;
                axios.get('/api/report/contact-notes-with-ls-and-as/')
                    .then(response => {
                        if (response.data.success) {
                            this.data = response.data.rows;

                            this.loading = false;
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            }
        },
        created() {
            this.load();
        }
    }
</script>
<style scoped>
</style>
